/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramGeoControllerGetCitiesQueryResponse,
  TelegramGeoControllerGetCitiesPathParams,
} from '../types/TelegramGeoControllerGetCities.ts';

function getTelegramGeoGetCitiesUrl(regionId: TelegramGeoControllerGetCitiesPathParams['regionId']) {
  const res = { method: 'GET', url: `/api/telegram/geo/cities/${regionId}` as const };
  return res;
}

/**
 * {@link /api/telegram/geo/cities/:regionId}
 */
export async function telegramGeoGetCities(
  regionId: TelegramGeoControllerGetCitiesPathParams['regionId'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<TelegramGeoControllerGetCitiesQueryResponse, ResponseErrorConfig<Error>, unknown>({
    method: 'GET',
    url: getTelegramGeoGetCitiesUrl(regionId).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
